var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m437 377v-302.742c0-40.946-33.312-74.258-74.257-74.258h-310.743v.013c-28.718.27-52 23.706-52 52.487v82.5h75v33.257c-42.511 7.163-75 44.227-75 88.743 0 26.596 11.599 50.529 30 67.02v126.008l45-30v17.715c0 40.946 33.312 74.257 74.257 74.257h310.743v-.013c28.718-.271 52-23.706 52-52.487v-82.5zm-407-324.5c0-12.406 10.093-22.5 22.5-22.5s22.5 10.094 22.5 22.5v52.5h-45zm60 144.5c33.084 0 60 26.916 60 60s-26.916 60-60 60-60-26.916-60-60 26.916-60 60-60zm-30 144.852c18.855 6.688 40.145 7.043 60 0v52.121l-30-20-30 20zm45 95.89v-17.715l45 30v-126.007c18.401-16.49 30-40.424 30-67.02 0-44.516-32.489-81.58-75-88.743 0-12.517 0-101.457 0-115.757 0-8.048-1.825-15.676-5.076-22.5h262.819c24.403 0 44.257 19.854 44.257 44.258v385.242c0 8.048 1.825 15.676 5.076 22.5h-262.819c-24.403 0-44.257-19.853-44.257-44.258zm377 21.758c0 12.406-10.094 22.5-22.5 22.5s-22.5-10.094-22.5-22.5v-52.5h45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 90h135v30h-135z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 167h135v30h-135z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 242h135v30h-135z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 317h135v30h-135z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 392h135v30h-135z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.ecba9b82d6159e8250de0b2fd3ae614d.svg";
export { ForwardRef as ReactComponent };